<ui-overlay
	[header]="'ai_chat.thumbs_down' | translate"
	[closeOnBackgroundClick]="true"
	[appendToBody]="true"
	(closeOverlay)="onCancel()"
>
	<div class="flex flex-col gap-4 p-1">
		<ui-textarea
			[value]="downvoteComment()"
			(valueChanged)="downvoteComment.set($event)"
			[placeholder]="'ai_chat.downvote_placeholder' | translate"
		></ui-textarea>
		<div class="flex justify-end gap-2">
			<ui-button
				type="secondary"
				[text]="'general.cancel' | translate"
				(buttonClicked)="onCancel()"
			></ui-button>
			<ui-button
				[text]="'ai_chat.submit_feedback' | translate"
				(buttonClicked)="onSubmitFeedback()"
			></ui-button>
		</div>
	</div>
</ui-overlay>
